import Advantage from './advantage'
export default [
  {
    path: '/advantage',
    name: 'home-advantage',
    component: Advantage
  }
]



// WEBPACK FOOTER //
// ./src/components/advantage/advantage-router.js